import { getApiUrl } from '../../util/api/api'
import type { ProductConfig } from '../../../state/reducers'
import { JobPostingProduct } from '../../../state/reducers/entitlement/entitlement'

const fetchUpgradeEntitlements = async (
  productConfig: ProductConfig
): Promise<any> => {
  const { publishOn, features, predefined = {} } = productConfig as JobPostingProduct

  if (Object.keys(predefined).length >= 1) {
    return Promise.resolve([])
  }

  const queryParams = new URLSearchParams()
  publishOn.forEach(site => queryParams.append("sites", site))
  features.forEach(feature => queryParams.append("features", feature))
  const response = await fetch(
    getApiUrl(`/dashboard/api/credits/upgrade?${queryParams.toString()}`),
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      mode: "cors"
    }
  )

  if (response?.ok) {
    const responseJson = await response.json()
    return Promise.resolve(responseJson)
  }

  return Promise.reject(response.statusText)
}


export default fetchUpgradeEntitlements
